function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.395 13.223a1.667 1.667 0 002.358 2.356c4.56-4.547 11.939-4.547 16.499 0 .312.313.737.488 1.179.488a1.653 1.653 0 001.66-1.628V14.4a1.654 1.654 0 00-.488-1.177c-5.861-5.843-15.345-5.843-21.207 0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.379 8.117C22.432.189 9.568.189 1.622 8.117a1.666 1.666 0 102.357 2.357c6.644-6.627 17.398-6.627 24.043 0a1.666 1.666 0 102.357-2.357zM19.177 16.044a9.669 9.669 0 00-10.012 2.281 1.666 1.666 0 001.178 2.845c.442 0 .867-.176 1.179-.489a6.33 6.33 0 018.703-.207c.083.073.175.133.253.207.312.311.734.485 1.175.485a1.668 1.668 0 001.177-2.847 9.58 9.58 0 00-3.652-2.276zM18.357 24.138a3.333 3.333 0 11-4.713 4.714 3.333 3.333 0 014.713-4.714z"
});

function SvgWifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2);
}

export default SvgWifi;